import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, palette, spacing, typography }) => ({
  root: props => ({
    width: '100%',
    marginTop: spacing(4),
    borderRadius: spacing(2),
    background: props?.variant === 'solid'
      ? palette.common.white
      : `linear-gradient(135deg, ${palette.common.white} 0%, ${palette.primary.shade[5]} 50%, ${palette.primary.shade[10]} 100%)`,
    border: `1px solid ${props?.useBrandBorder ? palette.primary.shade[20] : palette.grey.shade[10]}`
  }),
  content: {
    padding: spacing(4),
    [breakpoints.down('md')]: {
      padding: spacing(3)
    }
  },
  container: {
    // Grid container spacing handled by Grid component
  },
  leftSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(2),
    alignItems: 'flex-start'
  },
  badge: props => ({
    backgroundColor: props?.badgeVariant === 'dark' ? palette.text.primary : palette.primary.main,
    color: palette.common.white,
    fontWeight: typography.weight.semiBold,
    fontSize: typography.body.xs.fontSize,
    letterSpacing: '0.5px',
    height: 32,
    borderRadius: spacing(2),
    width: 'fit-content'
  }),
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing(2),
    marginTop: spacing(1)
  },
  programIconContainer: {
    width: 56,
    height: 56,
    borderRadius: spacing(1.5),
    backgroundColor: palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  programIcon: {
    fontSize: 28,
    color: palette.common.white
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1)
  },
  title: {
    ...typography.heading.h2,
    fontWeight: typography.weight.bold,
    color: palette.text.primary,
    margin: 0,
    padding: 0,
    lineHeight: 1
  },
  subtitle: {
    ...typography.body.m,
    color: 'rgba(0, 0, 0, 0.64)', // Darkened from palette.text.secondary for WCAG 2 AA contrast
    fontWeight: typography.weight.medium,
    margin: 0,
    padding: 0,
    lineHeight: 1
  },
  description: {
    ...typography.body.m,
    color: 'rgba(0, 0, 0, 0.64)', // Darkened from palette.text.secondary for WCAG 2 AA contrast
    lineHeight: 1.6,
    '& strong': {
      fontWeight: typography.weight.semiBold,
      color: palette.text.primary
    }
  },
  buttonContainer: {
    marginTop: spacing(2)
  },
  rightSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(3)
  },
  rightButtonSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    [breakpoints.down('md')]: {
      justifyContent: 'flex-start',
      marginTop: spacing(2)
    }
  },
  featureItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: spacing(2),
    alignItems: 'flex-start'
  },
  featureIcon: props => ({
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: props?.variant === 'solid' ? palette.grey[100] : palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      fontSize: 24,
      color: props?.variant === 'solid' ? palette.text.secondary : palette.primary.main
    }
  }),
  featureText: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0.5)
  },
  featureTitle: {
    ...typography.body.l,
    fontWeight: typography.weight.semiBold,
    color: palette.text.primary
  },
  featureDescription: {
    ...typography.body.s,
    color: palette.text.secondary
  },
  // Status indicator styles
  statusIndicator: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: spacing(0.5)
  },
  statusPending: {
    border: `2px solid ${palette.primary.main}`,
    backgroundColor: 'transparent'
  },
  statusCurrent: {
    border: `2px solid ${palette.primary.main}`,
    backgroundColor: 'transparent'
  },
  statusCurrentDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: palette.primary.main
  },
  statusCompleted: {
    border: 'none',
    backgroundColor: palette.primary.main
  },
  statusCheckIcon: {
    fontSize: 18,
    color: palette.common.white
  }
}))
